export const messages_hr = {
  error_default: "Nešto je pošlo po zlu. :(",
  username_taken: "Korisničko ime je već zauzeto",
  email_taken: "Email adresa je već zauzeta",
  passwords_not_matching: "Lozinke ne odgovaraju",
  password_too_short: "Lozinka mora sadržavati najmanje {0} znakova",
  password_needs_digit: "Lozinka mora sadržavati barem jednu znamenku",
  password_needs_uppercased: "Lozinka mora sadržavati barem jedno veliko slovo",
  password_needs_lowercased: "Lozinka mora sadržavati barem jedno malo slovo",
  password_not_allowed_special:
    "Lozinka ne smije sadržavati niti jedan posebni znak",
  registration_succes: "Uspješno ste se registrirali u sustav!",
  serverError:
    "Dogodila se pogreška u komunikaciji s poslužiteljem! Molimo pokušajte ponovo ili se obratite administratoru sustava.",
  delete_selected_confirm_message:
    "Jeste li sigurni da želite obrisati označene stavke?",
  documentsDeleteSuccess: "Dokument(i) uspješno obrisan(i)!",
  documentsUploadSuccess: "Dokument(i) uspješno učitan(i)!",
  nothingSelectedMessage:
    "Nema označene stavke. Označite stavku koju želite obrisati.",
  changesNotSavedMessage:
    "Promjene nisu spremljene, jeste li sigurni da želite napustiti stranicu?",
  reactivate_confirm_message: "Jeste li sigurni da želite reaktivirati stavku?",
  clientError:
    "Dogodila se pogreška na klijentu! Molimo pokušajte ponovo ili se obratite administratoru sustava.",
  settingsSaveSuccess: "Postavke uspješno spremljene!"
};
